
import { SmoothScroll } from "./js/smooth-scroll.js";
import { LoadMedias } from "./blocks/media/front/LoadMedias.js";
import { Header } from "./modules/header/Header.js";
import { Posts } from "./blocks/posts/Posts.js";
import { ContactForm } from "./blocks/form/types/ContactForm/ContactForm-front.js";
import { Slider } from "./blocks/slider/Slider.js";

document.addEventListener("DOMContentLoaded", e => {
    console.log({VDB_CONFIG});


    new SmoothScroll('.header-bottom a[href*="#"]', {
        speed: 500,
        easing: "easeInOutQuart",
        header: ".header",
    });

    const oncomplete = ($lastMedia, instance) => {
        console.log("complete");
        //Slider.init('SliderThumbnails');
    };

    new LoadMedias({ selector: ".imgdyn", type: "image", oncomplete /* ,delay:2999 */ }).load();
    const header = new Header();
    ContactForm.init();
    Slider.init("SliderSimple");console.log({header});
    //new ContactForm(document.querySelector(".form"));
    //new LoadMedias({ selector: ".videodyn", type: "video", oncomplete /* ,delay:999 */ }).load();

    Posts.init();
});